import React from "react";

const plantsData = [
    {
        name: "Neem",
        title: "The Medicinal Marvel",
        description:
            "Neem is a tree in the mahogany family known for its medicinal properties and is native to the Indian subcontinent. It is used in traditional medicine to treat various ailments. Neem oil is also used in cosmetics and skincare products. The leaves, bark, and seeds of the neem tree are used to make medicines. Neem is used for leprosy, eye disorders, bloody nose, intestinal worms, stomach upset, loss of appetite, skin ulcers, diseases of the heart and blood vessels (cardiovascular disease), fever, diabetes, gum disease (gingivitis), and liver problems. The bark is used for malaria, stomach and intestinal ulcers, skin diseases, pain, and fever.",
        image:
            "./images/featured-plant/neem.jpeg",
    },
    {
        name: "Peepal",
        title: "The Sacred Fig",
        description:
            "The Peepal tree is considered sacred in Hinduism and Buddhism and is also known as the Bodhi tree. It is believed to have spiritual and medicinal properties. The Peepal tree is used in traditional medicine to treat various ailments. The leaves, bark, and seeds of the Peepal tree are used to make medicines. Peepal is used for leprosy, eye disorders, bloody nose, intestinal worms, stomach upset, loss of appetite, skin ulcers, diseases of the heart and blood vessels (cardiovascular disease), fever, diabetes, gum disease (gingivitis), and liver problems. The bark is used for malaria, stomach and intestinal ulcers, skin diseases, pain, and fever.",
        image:
            "./images/featured-plant/peepal.jpeg",
    },
    {
        name: "Bamboo",
        title: "The Fastest Growing Plant",
        description:
            "Bamboo is the fastest-growing plant in the world and is used for a variety of purposes, including construction and food. It is a versatile plant that can be used for making furniture, paper, textiles, and more. Bamboo is also used in traditional medicine to treat various ailments. The leaves, bark, and seeds of the bamboo plant are used to make medicines. Bamboo is used for leprosy, eye disorders, bloody nose, intestinal worms, stomach upset, loss of appetite, skin ulcers, diseases of the heart and blood vessels (cardiovascular disease), fever, diabetes, gum disease (gingivitis), and liver problems. The bark is used for malaria, stomach and intestinal ulcers, skin diseases, pain, and fever.",
        image:
            "./images/featured-plant/bamboo.jpeg",
    },
];

const FeaturedPlant = () => {
    return (
        <section className="py-14 bg-gray-900">
            <div className="max-w-screen-xl mx-auto md:px-8">
                {plantsData.map((plant, index) => (
                    <div
                        key={index}
                        className={`items-center gap-x-12 sm:px-4 md:px-0 lg:flex ${index % 2 === 0 ? "" : "lg:flex-row-reverse"
                            } mb-14`}
                    >
                        <div className="flex-1">
                            <img
                                src={plant.image}
                                className="md:max-w-lg sm:rounded-lg"
                                alt={plant.name}
                            />
                        </div>
                        <div className="max-w-xl px-4 space-y-3 mt-6 sm:px-0 md:mt-0 lg:max-w-2xl">
                            <h3 className="text-indigo-400 font-semibold">{plant.name}</h3>
                            <p className="text-white text-3xl font-semibold sm:text-4xl">
                                {plant.name} - Beautiful and Beneficial
                            </p>
                            <p className="mt-3 text-gray-300">{plant.description}</p>
                            <a
                                href="javascript:void(0)"
                                className="inline-flex gap-x-1 items-center text-indigo-400 hover:text-indigo-500 duration-150 font-medium"
                            >
                                <button className="px-7 py-3 w-full bg-gray-700 text-gray-200 text-center rounded-md sm:w-auto hover:bg-gray-600 hover:scale-95 transform duration-150">
                                    Plant Now
                                </button>
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default FeaturedPlant;
